import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { NotificationService } from '../../../shared/services/notification.service';
import { unwrapV2 } from '../../../shared/utils/v2-api-response.util';
import { CLASIFICADOR_GASTOS_CATALOG } from '../../../../modules/expense/expenses/clasificador-gastos.catalog';

// Clasificación de gasto por defecto de un proveedor (asociaciones/fundaciones, SQL V117): al elegir el proveedor en una línea
// de gasto sin clasificar, la línea toma esta partida / subpartida / familia; lo que el usuario ya haya puesto no se toca.
@Component({
  selector: 'app-contact-expense-classification',
  templateUrl: './contact-expense-classification.component.html',
  styleUrls: ['./contact-expense-classification.component.css'],
  standalone: false,
})
export class ContactExpenseClassificationComponent implements OnInit {
  @Input() contactUid = '';

  readonly catalog = CLASIFICADOR_GASTOS_CATALOG;

  loading = true;
  loadError = false;
  saving = false;
  saveError = '';

  partida: string | null = null;
  subpartida: string | null = null;
  familia: string | null = null;

  constructor(private http: HttpClient, private notify: NotificationService) { }

  ngOnInit(): void {
    this.load();
  }

  private get url(): string {
    return `${environment.apiUrl}/api/v2/contacts/${this.contactUid}/expense-classification`;
  }

  get subpartidas() {
    const partida = this.catalog.find(p => p.nombre === this.partida);
    return partida ? partida.subpartidas : [];
  }

  get familias(): string[] {
    const subpartida = this.subpartidas.find(s => s.nombre === this.subpartida);
    return subpartida ? subpartida.familias : [];
  }

  onPartidaChange(): void {
    this.subpartida = null;
    this.familia = null;
  }

  onSubpartidaChange(): void {
    this.familia = null;
  }

  clear(): void {
    this.partida = null;
    this.subpartida = null;
    this.familia = null;
  }

  retry(): void {
    this.load();
  }

  save(): void {
    if (this.saving) return;
    this.saveError = '';
    if (this.partida && this.subpartidas.length > 0 && !this.subpartida) {
      this.saveError = 'Indica la subpartida.';
      return;
    }

    this.saving = true;
    const body = { partida: this.partida, subpartida: this.subpartida, familia: this.familia };
    unwrapV2(firstValueFrom(this.http.put<any>(this.url, body)), 'No se pudo guardar la clasificación')
      .then(() => this.notify.ok(this.partida ? 'Clasificación guardada correctamente' : 'Clasificación eliminada'))
      .catch(error => { this.saveError = (error && error.error && error.error.message) || 'No se pudo guardar la clasificación.'; })
      .then(() => { this.saving = false; });
  }

  private load(): void {
    this.loading = true;
    this.loadError = false;
    unwrapV2(firstValueFrom(this.http.get<any>(this.url)), 'No se pudo cargar la clasificación')
      .then((dto: any) => {
        this.partida = dto.partida || null;
        this.subpartida = dto.subpartida || null;
        this.familia = dto.familia || null;
      })
      .catch(() => { this.loadError = true; })
      .then(() => { this.loading = false; });
  }
}
